module.exports = __webpack_public_path__ + "static/media/AwsDoc4.d9e4867a.png";